import { render, staticRenderFns } from "./CreditTotalizersUpsert.vue?vue&type=template&id=63ef57ae&scoped=true"
import script from "./CreditTotalizersUpsert.vue?vue&type=script&lang=ts"
export * from "./CreditTotalizersUpsert.vue?vue&type=script&lang=ts"
import style0 from "./CreditTotalizersUpsert.vue?vue&type=style&index=0&id=63ef57ae&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ef57ae",
  null
  
)

export default component.exports